import {Tuple3, Tuple6} from '@shared/lib/utils/tuple_utils';

export function localeDateString(date: Date): string {
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const dateStr = [
    date.getFullYear().toString(),
    (date.getMonth() + 1).toString().padStart(2, '0'),
    date.getDate().toString().padStart(2, '0'),
  ].join('-');
  return dateStr;
}

export function utcDateString(date: Date): string {
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const dateStr = [
    date.getUTCFullYear().toString(),
    (date.getUTCMonth() + 1).toString().padStart(2, '0'),
    date.getUTCDate().toString().padStart(2, '0'),
  ].join('-');
  return dateStr;
}

export function localeTimeString(date: Date): string {
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const timeStr = [
    date.getHours().toString().padStart(2, '0'),
    date.getMinutes().toString().padStart(2, '0'),
    date.getSeconds().toString().padStart(2, '0'),
  ].join(':');
  return timeStr;
}

export function utcTimeString(date: Date): string {
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const timeStr = [
    date.getUTCHours().toString().padStart(2, '0'),
    date.getUTCMinutes().toString().padStart(2, '0'),
    date.getUTCSeconds().toString().padStart(2, '0'),
  ].join(':');
  return timeStr;
}

export function localeDateTimeString(date: Date): string {
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const dateStr = localeDateString(date);
  const timeStr = localeTimeString(date);
  return [dateStr, timeStr].join(' ');
}

export function localeDate(str: string): Date {
  const [yearStr, monthStr, dayStr] = str.split('-');

  const dateComponents: number[] = [];
  for (const val of [yearStr, monthStr, dayStr]) {
    if (val === undefined) {
      return new Date(Number.NaN);
    }
    const component = Number.parseFloat(val);
    if (Number.isNaN(component)) {
      return new Date(Number.NaN);
    }
    dateComponents.push(component);
  }

  const [year = 0, month = 0, day] = dateComponents;
  return new Date(year, month - 1, day);
}

export function utcDate(str: string): Date {
  const [yearStr, monthStr, dayStr] = str.split('-');

  const dateComponents: number[] = [];
  for (const val of [yearStr, monthStr, dayStr]) {
    if (val === undefined) {
      return new Date(Number.NaN);
    }
    const component = Number.parseFloat(val);
    if (Number.isNaN(component)) {
      return new Date(Number.NaN);
    }
    dateComponents.push(component);
  }

  const [year = 0, month = 0, day] = dateComponents;
  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
}

export function localeDateTime(str: string): Date {
  const [dateStr, timeStr] = str.split(' ');
  if (dateStr === undefined || timeStr === undefined) {
    return new Date(Number.NaN);
  }
  const [yearStr, monthStr, dayStr] = dateStr.split('-');
  const [hoursStr, minutesStr, secondsStr] = timeStr.split(':');

  const dateComponents: number[] = [];
  for (const val of [yearStr, monthStr, dayStr]) {
    if (val === undefined) {
      return new Date(Number.NaN);
    }
    const component = Number.parseFloat(val);
    if (Number.isNaN(component)) {
      return new Date(Number.NaN);
    }
    dateComponents.push(component);
  }

  for (const val of [hoursStr, minutesStr, secondsStr]) {
    if (val === undefined) {
      const [year, month, day] = dateComponents as Tuple3<number>;
      return new Date(year, month - 1, day);
    }
    const component = Number.parseFloat(val);
    if (Number.isNaN(component)) {
      return new Date(Number.NaN);
    }
    dateComponents.push(component);
  }

  const [year, month, day, hours, minutes, seconds] = dateComponents as Tuple6<number>;
  return new Date(year, month - 1, day, hours, minutes, seconds);
}

export function utcDateTime(str: string): Date {
  const [dateStr, timeStr] = str.split(' ');
  if (dateStr === undefined || timeStr === undefined) {
    return new Date(Number.NaN);
  }
  const [yearStr, monthStr, dayStr] = dateStr.split('-');
  const [hoursStr, minutesStr, secondsStr] = timeStr.split(':');

  const dateComponents: number[] = [];
  for (const val of [yearStr, monthStr, dayStr]) {
    if (val === undefined) {
      return new Date(Number.NaN);
    }
    const component = Number.parseFloat(val);
    if (Number.isNaN(component)) {
      return new Date(Number.NaN);
    }
    dateComponents.push(component);
  }

  for (const val of [hoursStr, minutesStr, secondsStr]) {
    if (val === undefined) {
      const [year, month, day] = dateComponents as Tuple3<number>;
      return new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
    }
    const component = Number.parseFloat(val);
    if (Number.isNaN(component)) {
      return new Date(Number.NaN);
    }
    dateComponents.push(component);
  }

  const [year, month, day, hours, minutes, seconds] = dateComponents as Tuple6<number>;
  return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
}
